/**
 * servicing eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrderSeatItemSeatSelectionSeatCharacteristicsInner } from './orderSeatItemSeatSelectionSeatCharacteristicsInner';

/**
 * 座席指定
 */
export interface OrderSeatItemSeatSelection {
  /**
   * 座席番号。SSRステータスがHK/KKの座席番号。<br/> カウチについて<br/> SSR RQSTを保持している座席番号を返却<br/> エキストラシート、キャビンバゲージについては<br/> 1座席目の座席番号がSSR RQSTに、2座席目以降の座席番号がSSR CKINに登録されているので、それぞれの内容を返却する<br/> 上記以外の場合、座席番号を返却
   */
  seatNumbers?: Array<string>;
  /**
   * 座席番号。SSRステータスがUN/NO/UCの座席番号。<br/> カウチについて<br/> SSR RQSTを保持している座席番号を返却<br/> エキストラシート、キャビンバゲージについては<br/> 1座席目の座席番号がSSR RQSTに、2座席目以降の座席番号がSSR CKINに登録されているので、それぞれの内容を返却する<br/> 上記以外の場合、座席番号を返却
   */
  cancelledSeatNumbers?: Array<string>;
  /**
   * カウチ座席番号<br/> カウチ座席番号はフリーテキストにSKYLINKを含むRMエレメントから取得する。<br/> RMエレメント中の当PNR座席番号に、当該搭乗者の座席番号が含まれている場合、<br/> そのRMエレメントからカウチ座席番号を求めて返却する。<br/> カウチ座席番号は、「当PNR座席番号」「NCP座席番号」「別PNR座席番号」の3つに共通で含まれる行番号＋3つに含まれるアルファベットを<br/> ABC順で並べ替えた文字列とする。<br/> ※RMエレメントのフォーマットは以下を想定。末尾の別PNR情報は任意項目となり、別PNRの個数分、<br/> 「“/”+ 別PNR予約番号 + “/”+ 別PNR座席番号」の形式の情報が繰り返される。<br/> フォーマット定義に合わない情報であった場合は、そのRMエレメントは読み捨てる。<br/> “SKYLINK/” + プライマリ識別 + “/” + プライマリ予約番号 + “/”+ SSRコード + “/”+ 当PNR座席番号 + “/” + NCP作成状態+ “/”+ NCP予約番号 + “/” + NCP座席番号 + 別PNR情報
   */
  couchSeatNumber?: string;
  /**
   * カウチ代表者かどうか。SSR COxx（xxにはAA～BDの文字列）を持っている場合、true。
   */
  isCouchRepresentative: boolean;
  /**
   * 座席属性<br/> SSR NSSTを持っている場合、どちらかの文字を返却する<br/> W：窓側リクエスト中<br/> A：通路側リクエスト中
   */
  characteristicRequestSsrCode?: string;
  /**
   * SSRステータスとAncillaryのEMDの状態に応じたサービスの申込状態。エキストラシート/キャビンバゲージで座席が複数ある場合は、SSR RQSTを基に判定する。<br/> prebooked<br/> 有料席についてSSRのみ作成して離脱してしまった状態。<br/> 有料ASR席、カウチ席(カウチ代表者が保持するカウチのSSRと当該カウチに座る全搭乗者)（以降、カウチ席全体）のSSRステータスがHK/KKで、SSRに紐づくTSMが存在するが、EMDが存在しない場合。<br/> confirmed<br/> 以下のいずれかに合致する場合<br/> 1 有料ASR席またはカウチ席全体でSSRステータスがHK/KKで、SSRに紐づくTSM、EMDが存在する<br/> 2 通常席(有料ASR席、カウチ席以外)でSSRステータスがHK/KK<br/> cancelled<br/> 以下のいずれかに合致する場合<br/> 1 有料ASR席またはカウチ席全体の1つでも、SSRステータスがUN/NO/UCを含む<br/> 2 通常席(有料ASR席、カウチ席以外)でSSRステータスがUN/NO/UC<br/> requesting<br/> 以下のいずれかに合致する場合 1 カウチ全体について、SSRステータスがいずれもUN/NO/UCを含まないかつ、1つでもHNを含む 2 通常席(カウチ席以外)でSSRステータスがHN
   */
  serviceStatus?: OrderSeatItemSeatSelection.ServiceStatusEnum;
  /**
   * 座席特性
   */
  seatCharacteristics?: Array<OrderSeatItemSeatSelectionSeatCharacteristicsInner>;
  /**
   * 有料座席の場合にtrueを返却する
   */
  isChargeable?: boolean;
  /**
   * DxAPIにおける座席指定情報のID。エキストラシート/キャビンバゲージで座席が複数ある場合は、SSR RQSTのID。
   */
  seatId?: Array<string>;
  /**
   * DxAPIにおけるSSR COxx（xxにはAA～BDの文字列）のID
   */
  couchId?: string;
}
export namespace OrderSeatItemSeatSelection {
  export type ServiceStatusEnum = 'prebooked' | 'confirmed' | 'cancelled' | 'requesting';
  export const ServiceStatusEnum = {
    Prebooked: 'prebooked' as ServiceStatusEnum,
    Confirmed: 'confirmed' as ServiceStatusEnum,
    Cancelled: 'cancelled' as ServiceStatusEnum,
    Requesting: 'requesting' as ServiceStatusEnum,
  };
}
